'use client';
import { useEsportStreamingControl } from '@/hooks/query/use-esport-streaming-data';
import { useEffect, useState } from 'react';
import { useStreamingStore } from '@/store/streaming';
import { VideoDeviceType } from '@/services/streaming.service';
import { IframeBase, VideoBase } from '../streaming-base';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAccountInfo } from '@/hooks/query/account';
import React from 'react';
import { MatchModelBase } from '@nf/types/odds';
import { switchViewService } from '@/services/swtich-view.service';
import { SiteConfigsSettingsData } from '@nf/types/site';
import { esportOptionLangMapping } from '@/settings/esport-setting';
import { useStore } from '@/hooks';
import { useSiteStore } from '@/store/site';

// export const EsportVideo: React.FC<{ match?: MatchModelBase; device: VideoDeviceType }> = ({ match, device }) => {
export const EsportVideo = ({ match, device }: { match: MatchModelBase, device: VideoDeviceType }) => {
	const { user } = useAccountInfo();
	const [esportSourceType, setEsportSourceType] = useState<number>(0);
	const homeUrl = useStore(useSiteStore, state => state.deepLinkSiteInfo.homeUrl);
	const { SiteConfigsData } = useGetSiteConfigs();
	useEsportStreamingControl(match?.MatchId ?? 0);
	const [
		esportchannelList,
		setStreamingUrl,
		esportSrc,
		setEsportSrc,
		setIsLoading
	] = useStreamingStore(
		state => [
			state.esportchannelList,
			state.setStreamingUrl,
			state.esportSrc,
			state.setEsportSrc,
			state.setIsLoading
		]
	);
	const { hostname } = location;
	const getTwitchUrl = (url: string) => {
		const baseUrl = url + `&parent=${hostname}`;
		const originalRefer = user?.LicenseeSiteSetting?.OriginalRefer ?? homeUrl;
		
		if (!originalRefer) {
			return baseUrl;
		}

		const parentDomain = originalRefer.replace(/^(https?:\/\/)?/, '').split('/')[0];
		return baseUrl + `&parent=${parentDomain}`;
	};
	useEffect(() => {
		setEsportSrc('');
	}, [match?.MatchId]);

	//Source Select
	let currentEsportData = esportchannelList.find((item) => item.value === esportSrc);
	if (!currentEsportData && esportchannelList.length > 0) {
		const shortCode = switchViewService.convertLanguageToShortCode(user?.Lang as string, SiteConfigsData as SiteConfigsSettingsData);
		const foundEntry = Object.entries(esportOptionLangMapping).find(([key, value]) => value.sName === shortCode);
		if (foundEntry) {
			currentEsportData = esportchannelList.find((item) => item.lang.toString() === foundEntry[0]);
		} else {
			currentEsportData = esportchannelList[0];
		}
		setEsportSrc(!currentEsportData ? esportchannelList[0].value : currentEsportData.value.toString());
	}

	setIsLoading(false);

	switch (currentEsportData?.sourceType) {
		case 1:
			let esportUrl = currentEsportData.url;
			if (esportUrl.indexOf('?') > -1) {
				esportUrl = esportUrl + '&playsinline=1';
			} else {
				esportUrl = esportUrl + '?playsinline=1';
			}
			setStreamingUrl(esportUrl);
			break;
		case 2:
		case 3:
		case 4:
		case 6:
		case 7:
			setStreamingUrl(currentEsportData.url);
			break;
		case 8:
			setEsportSourceType(8);
			setStreamingUrl(currentEsportData.url);
		case 5:
			setStreamingUrl(getTwitchUrl(currentEsportData.url));
			break;
	}
	return (
		<>
			{
				(esportSourceType === 8) ?
					<VideoBase device={device} /> : <IframeBase />
			}
		</>
	)
};

